// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './app'
import router from './router'
import axios from 'axios'
import moment from 'moment'
import lang from 'element-ui/lib/locale/lang/fr'
import locale from 'element-ui/lib/locale'
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Divider,
  Drawer,
  Form,
  FormItem,
  Input,
  MessageBox,
  Notification,
  Option,
  Radio,
  RadioGroup,
  Rate,
  Row,
  Select,
  Step,
  Steps,
  Upload
} from 'element-ui'
import './assets/scss/element-ui.scss'

axios.defaults.baseURL = '/'
axios.defaults.timeout = 60000

if (process.env.API_URL) {
  axios.defaults.baseURL = process.env.API_URL + '/'
}

moment.locale('fr')

locale.use(lang)
Vue.component(Alert.name, Alert)
Vue.component(Button.name, Button)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Card.name, Card)
Vue.component(Col.name, Col)
Vue.component(Collapse.name, Collapse)
Vue.component(CollapseItem.name, CollapseItem)
Vue.component(DatePicker.name, DatePicker)
Vue.component(Dialog.name, Dialog)
Vue.component(Divider.name, Divider)
Vue.component(Drawer.name, Drawer)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Input.name, Input)
Vue.component(Option.name, Option)
Vue.component(Radio.name, Radio)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(Rate.name, Rate)
Vue.component(Row.name, Row)
Vue.component(Select.name, Select)
Vue.component(Step.name, Step)
Vue.component(Steps.name, Steps)
Vue.component(Upload.name, Upload)
Vue.api = axios.create()
Vue.config.productionTip = false
Vue.prototype.$notify = Notification
Vue.prototype.$confirm = MessageBox.confirm

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  router,
  data() {
    return {
      stripeKey: process.env.STRIPE_KEY
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js